/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Verified_SuccessInputs */

const en_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your email address has been verified. You can now close this window.`)
};

const id_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email Anda telah diverifikasi. Anda sekarang dapat menutup jendela ini.`)
};

const ms_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat emel anda telah disahkan. Anda kini boleh menutup tetingkap ini.`)
};

const ca_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La teva adreça de correu electrònic ha estat verificada. Ara pots tancar aquesta finestra.`)
};

const cs_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše emailová adresa byla ověřena. Nyní můžete toto okno zavřít.`)
};

const da_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din e-mailadresse er blevet bekræftet. Du kan nu lukke dette vindue.`)
};

const de_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre E-Mail-Adresse wurde verifiziert. Sie können dieses Fenster jetzt schließen.`)
};

const et_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie e-posti aadress on kinnitatud. Nüüd saate selle akna sulgeda.`)
};

const es_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dirección de correo electrónico ha sido verificada. Ahora puedes cerrar esta ventana.`)
};

const fr_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre adresse e-mail a été vérifiée. Vous pouvez maintenant fermer cette fenêtre.`)
};

const hr_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša e-mail adresa je potvrđena. Sada možete zatvoriti ovaj prozor.`)
};

const it_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo indirizzo email è stato verificato. Ora puoi chiudere questa finestra.`)
};

const lv_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu e-pasta adrese ir apstiprināta. Tagad varat aizvērt šo logu.`)
};

const lt_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų el. pašto adresas buvo patvirtintas. Dabar galite uždaryti šį langą.`)
};

const hu_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az e-mail címet ellenőrizték. Most bezárhatja ezt az ablakot.`)
};

const nl_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je e-mailadres is geverifieerd. Je kunt dit venster nu sluiten.`)
};

const nb_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-postadressen er bekreftet. Du kan nå lukke dette vinduet.`)
};

const pl_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój adres e-mail został zweryfikowany. Teraz możesz zamknąć to okno.`)
};

const pt_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu endereço de e-mail foi verificado. Você já pode fechar esta janela.`)
};

const ro_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa dvs. de e-mail a fost verificată. Acum puteți închide această fereastră.`)
};

const sk_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša e-mailová adresa bola overená. Teraz môžete toto okno zatvoriť.`)
};

const sl_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaš e-poštni naslov je bil preverjen. Sedaj lahko zaprete to okno.`)
};

const fi_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköpostiosoitteesi on vahvistettu. Voit nyt sulkea tämän ikkunan.`)
};

const sv_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din e-postadress har verifierats. Du kan nu stänga detta fönster.`)
};

const vi_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email của bạn đã được xác minh. Bây giờ bạn có thể đóng cửa sổ này.`)
};

const tr_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresiniz doğrulandı. Artık bu pencereyi kapatabilirsiniz.`)
};

const el_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η διεύθυνση email σας έχει επαληθευτεί. Μπορείτε τώρα να κλείσετε αυτό το παράθυρο.`)
};

const bg_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашият имейл адрес беше потвърден. Вече можете да затворите този прозорец.`)
};

const ru_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты подтвержден. Теперь вы можете закрыть это окно.`)
};

const sr_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша емаил адреса је верификована. Можете затворити овај прозор.`)
};

const uk_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша адреса електронної пошти підтверджена. Тепер ви можете закрити це вікно.`)
};

const ka_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი მეილის მისამართი დადასტურებულია. შეგიძლიათ დახუროთ ეს ფანჯარა.`)
};

const hi_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका ईमेल पता सत्यापित हो गया है। आप अब यह विंडो बंद कर सकते हैं।`)
};

const th_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่อยู่อีเมลของคุณได้รับการยืนยันแล้ว คุณสามารถปิดหน้าต่างนี้ได้`)
};

const ko_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소가 확인되었습니다. 이제 이 창을 닫을 수 있습니다.`)
};

const zh_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的电子邮件地址已验证。您现在可以关闭此窗口。`)
};

const zh_tw_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的電子郵件地址已完成驗證。現在您可以關閉此視窗。`)
};

const ja_email_verified_success = /** @type {(inputs: Email_Verified_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスが認証されました。このウィンドウを閉じることができます。`)
};

/**
* | output |
* | --- |
* | "Your email address has been verified. You can now close this window." |
*
* @param {Email_Verified_SuccessInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const email_verified_success = /** @type {((inputs?: Email_Verified_SuccessInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Verified_SuccessInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_email_verified_success(inputs)
	if (locale === "ms") return ms_email_verified_success(inputs)
	if (locale === "ca") return ca_email_verified_success(inputs)
	if (locale === "cs") return cs_email_verified_success(inputs)
	if (locale === "da") return da_email_verified_success(inputs)
	if (locale === "de") return de_email_verified_success(inputs)
	if (locale === "et") return et_email_verified_success(inputs)
	if (locale === "es") return es_email_verified_success(inputs)
	if (locale === "fr") return fr_email_verified_success(inputs)
	if (locale === "hr") return hr_email_verified_success(inputs)
	if (locale === "it") return it_email_verified_success(inputs)
	if (locale === "lv") return lv_email_verified_success(inputs)
	if (locale === "lt") return lt_email_verified_success(inputs)
	if (locale === "hu") return hu_email_verified_success(inputs)
	if (locale === "nl") return nl_email_verified_success(inputs)
	if (locale === "nb") return nb_email_verified_success(inputs)
	if (locale === "pl") return pl_email_verified_success(inputs)
	if (locale === "pt") return pt_email_verified_success(inputs)
	if (locale === "ro") return ro_email_verified_success(inputs)
	if (locale === "sk") return sk_email_verified_success(inputs)
	if (locale === "sl") return sl_email_verified_success(inputs)
	if (locale === "fi") return fi_email_verified_success(inputs)
	if (locale === "sv") return sv_email_verified_success(inputs)
	if (locale === "vi") return vi_email_verified_success(inputs)
	if (locale === "tr") return tr_email_verified_success(inputs)
	if (locale === "el") return el_email_verified_success(inputs)
	if (locale === "bg") return bg_email_verified_success(inputs)
	if (locale === "ru") return ru_email_verified_success(inputs)
	if (locale === "sr") return sr_email_verified_success(inputs)
	if (locale === "uk") return uk_email_verified_success(inputs)
	if (locale === "ka") return ka_email_verified_success(inputs)
	if (locale === "hi") return hi_email_verified_success(inputs)
	if (locale === "th") return th_email_verified_success(inputs)
	if (locale === "ko") return ko_email_verified_success(inputs)
	if (locale === "zh") return zh_email_verified_success(inputs)
	if (locale === "zh-tw") return zh_tw_email_verified_success(inputs)
	if (locale === "ja") return ja_email_verified_success(inputs)
	return en_email_verified_success(inputs)
});